(() => {
  // Ensure GSAP exists
  if (!window.gsap) return;

  // Register ScrollToPlugin ONLY on this page
  // (ScrollSmoother is already registered in your global)
  if (window.ScrollToPlugin) {
    gsap.registerPlugin(ScrollToPlugin);
  } else if (gsap?.plugins?.ScrollToPlugin) {
    // already registered/available
  } else {
    console.warn("ScrollToPlugin not found on this page.");
    return;
  }

  // Optional helper: wait for injected elements (Klaviyo/forms/sections)
  const waitForEl = (selector, timeout = 8000) =>
    new Promise((resolve, reject) => {
      const start = performance.now();
      const tick = () => {
        const el = document.querySelector(selector);
        if (el) return resolve(el);
        if (performance.now() - start > timeout) return reject(new Error("timeout"));
        requestAnimationFrame(tick);
      };
      tick();
    });

  async function scrollToSignup({ offsetY = 0, duration = 1 } = {}) {
    let target = document.querySelector("#sign-up-form");

    // If your form is injected late, this prevents "works sometimes"
    if (!target) {
      try {
        target = await waitForEl("#sign-up-form", 8000);
      } catch {
        console.warn("Could not find #sign-up-form (timed out).");
        return;
      }
    }

    // No need to store instance: just fetch at runtime
    const s = window.ScrollSmoother?.get?.();

    if (s) {
      // ScrollSmoother route (best when active)
      const y = s.offset(target, "top top") + offsetY;
      gsap.to(s, { scrollTop: y, duration, ease: "power2.out" });
    } else {
      // Fallback route (mobile < 750px / design mode / smoother not created)
      gsap.to(window, {
        duration,
        ease: "power2.out",
        scrollTo: { y: target, offsetY: -offsetY, autoKill: true }
      });
    }
  }

  // Works for either a data attribute OR normal anchor links
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest('[data-scroll-to="signup"], a[href="#sign-up-form"]');
    if (!trigger) return;
    e.preventDefault();

    // Adjust offsetY if you have a sticky header
    scrollToSignup({ offsetY: 0, duration: 1 });
  });

  // Optional: if the page loads with #sign-up-form in the URL
  window.addEventListener("load", () => {
    if (window.location.hash === "#sign-up-form") {
      scrollToSignup({ offsetY: 0, duration: 1 });
    }
  });
})();
